import flow from 'lodash/flow';
import {
  getServerValidationErrors,
  mapPropsToValidators,
  validate,
} from '../validators';
import { validateOpenRequired } from '../open/validators';
import { simpleOpenUpdate } from '../open/reducer';
import { commonQuestionState, updateWhy } from '../response/reducer';

const addValidators = ({ number_of_fields = 1, required }) => state => ({
  ...state,
  validators: mapPropsToValidators(
    {
      required: required,
    },
    {
      required: validateOpenRequired(number_of_fields),
    }
  ),
});

const addValue = state => ({
  ...state,
  values: [
    {
      index: 0,
      isTouched: false,
      value: '',
    },
  ],
});

const reducer = props => (state, action) => {
  if (state === undefined) {
    return flow(
      commonQuestionState(props),
      addValidators(props),
      getServerValidationErrors(props),
      addValue
    )({});
  }

  switch (action.type) {
    // When we start changing the value it should automatically clear any server validation errors
    case 'PASSWORD_CHANGE':
      return flow(simpleOpenUpdate(action), validate(action))(state);

    case 'PASSWORD_BLUR':
      return flow(updateIsTouched(action), validate(action))(state);

    case 'WHY_CHANGE':
      return flow(updateWhy(action), validate(action))(state);

    case 'SUBMIT':
      return flow(updateIsTouched(action), validate(action))(state);

    default:
      return state;
  }
};

export default reducer;

const updateIsTouched = () => state => ({
  ...state,
  values: state.values.map(value => ({
    ...value,
    isTouched: true,
  })),
});
